export default __webpack_public_path__ + "static/media/image.c6219612.svg";